import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DATA_CREATE_REQUEST_SUMMARY } from 'models/create-request';

export interface baseRequest {
  stepBaseRequest: number;
  urlServiceAgreementPDF: string;
  overallDataSubmit: DATA_CREATE_REQUEST_SUMMARY;
}

export const initialRequestState: baseRequest = {
  stepBaseRequest: 1,
  urlServiceAgreementPDF: '',
  overallDataSubmit: {
    addChild: {
      children: [],
      isAccepted: false,
    },
    requestDetail: {
      startDate: null,
      endDate: null,
      startTime: null,
      endTime: null,
      dayOfWeeks: [],
      specialRequirements: '',
      pets: [],
      children: [],
      address: null,
      isAccepted: false,
    },
    parentSignature: '',
  },
};

const baseRequestSlice = createSlice({
  name: 'baseRequest',
  initialState: initialRequestState,
  reducers: {
    updateOverallDataSubmit(
      state: baseRequest,
      action: PayloadAction<DATA_CREATE_REQUEST_SUMMARY>,
    ) {
      state.overallDataSubmit = action.payload;
    },
    updateStepTrial(state: baseRequest, action: PayloadAction<number>) {
      state.stepBaseRequest = action.payload;
    },
    updateUrlServiceAgreementPDF(
      state: baseRequest,
      action: PayloadAction<string>,
    ) {
      state.urlServiceAgreementPDF = action.payload;
    },
  },
});

export const {
  updateStepTrial,
  updateOverallDataSubmit,
  updateUrlServiceAgreementPDF,
} = baseRequestSlice.actions;

export default baseRequestSlice.reducer;
